/**
 * main.ts — point d'entrée unique du runtime O1X (bundle o1x.js, esbuild).
 *
 * L'entrée se boote elle-même (self-booting bundle) : main.ts est l'amorce
 * réelle, en ESM.
 *
 * 1. Side-effect imports des controllers → chacun s'enregistre dans
 *    `ControllerRegistry` au top-level (dispatch par nom : Entity/App,
 *    Entity/AppMenu, Entity/Menu). Sans ces imports, `create(name)` throw.
 * 2. `init()` (o1xha) → O1XWebPage → HorApp (le moteur de rendu) au DOM ready.
 */
// Slot ServiceManager (recette §3.1) : registerServiceManager s'exécute à l'import.
// Sans ce side-effect, le wrap `services → ServiceManager` reste dormant et
// `getServiceManager().getService()` crashe au boot (HAObject).
import "./ha/Core/ServiceManager";
// Slot DataRepository : registerDataRepository(Data) à l'import → getDataRepository()
// renvoie la vraie Repository/Data (sinon stub {} → .fetchData crashe au boot).
import "./ha/Core/Repository/Data";
import "./ha/Core/Controller/HTML/AppMenu";
import "./ha/Core/Controller/Menu/Menu";
import "./ha/Core/Controller/Menu/MenuItem";
import "./ha/Core/Controller/Navigation/AppInfo";
import "./ha/Core/Controller/Navigation/DashboardNavigation";
import "./ha/Core/Controller/Navigation/NavBack";
import "./ha/Core/Controller/Navigation/Navigation";
import "./ha/Core/Controller/Navigation/NavigationItem";
import "./ha/Core/Controller/Navigation/NavigationUser";
import "./ha/Core/Controller/Page/MenuController";
import "./ha/Core/Controller/Page/PageController";
import "./ha/Core/Controller/Page/SearchableController";
import "./ha/Core/Controller/ResultListController";
// Custom Elements hauser (consent-banner RGPD, user-chip, mfa-prompt) + HauserApi :
// s'auto-définissent à l'import (customElements.define). Branchés DANS o1x.js
// (ha/443j) — plus de build « à côté » (tsconfig.hauser/dist-runtime-esm obsolète).
import "./hauser/index";
import { init } from "./ha/o1x/app/o1xha";

function boot(): void {
    init(() => undefined);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
} else {
    boot();
}
